/* eslint-disable no-nested-ternary */
import React from 'react';

import { IoIosWarning } from 'react-icons/io';
import { BiX } from 'react-icons/bi';

import useEditOrder from './useEditOrder';

import * as S from './styles';

import Button from '../../newComponents/Button';
import ProductModal from '../NewOrder/components/ModalProduct';
import ProductEditModal from '../NewOrder/components/ModalProductEdit';

import { MainFinish } from '../NewOrder/components/MainFinish';
import Aside from '../NewOrder/components/Aside';
import MainProducts from '../NewOrder/components/MainProducts';
import { useAuth } from '../../hooks/auth';

export default function EditOrder(): JSX.Element {
  const { user } = useAuth();
  const {
    orderId,
    cart,
    cartIsLoading,
    selectedDeliveryType,
    selectedClient,
    selectedAddress,
    selectedCoupon,
    seletedProductId,
    selectdePaymentMethod,
    scheduledDelivery,
    seletedEditCartItemId,
    colorsAndSizesAll,
    asideIsClosed,
    asideIsOpen,
    isLoading,
    setIsLoading,
    setAsideIsOpen,
    setAsideisClosed,
    setSeletedEditCartItemId,
    setSelectedPaymentMethod,
    addItemToCart,
    editItemToCart,
    removeItemToCart,
    setSeletedProductId,
    setSelectedCoupon,
    setDeliveryType,
    handleFinalizeOrder,
    setScheduledDelivery,
    deliveryFee,
    discountOnTheOutside,
    finalPrice,
    history,
    modalCancelRef,
    modalCreateUserRef,
    nextStep,
    prevStep,
    setDiscountOnTheOutside,
    step,
    theme,
    order,
    observation,
    setObservation,
  } = useEditOrder();

  return (
    <S.Container asideIsClosed={asideIsClosed} asideIsOpen={asideIsOpen}>
      {step === 0 ? (
        <MainProducts
          cart={cart}
          setSeletedProductId={setSeletedProductId}
          selectedClient={selectedClient}
          order={order}
          orderId={orderId}
          setAsideisClosed={setAsideisClosed}
          finalPrice={finalPrice}
        />
      ) : null}
      {step === 1 ? (
        <MainFinish
          setSelectedCompanyId={console.log}
          isEditing
          companies={[]}
          distances={[]}
          selectedCompanyId={user.empresa_id}
          cart={cart}
          scheduledDelivery={scheduledDelivery}
          setScheduledDelivery={setScheduledDelivery}
          selectedCoupon={selectedCoupon}
          setSelectedCoupon={setSelectedCoupon}
          setSelectedPaymentMethod={setSelectedPaymentMethod}
          selectedPaymentMethod={selectdePaymentMethod}
          finalPrice={finalPrice}
          setDiscountOnTheOutside={setDiscountOnTheOutside}
          prevStep={prevStep}
          selectedClient={selectedClient}
          observation={observation}
          setObservation={setObservation}
          discountOnTheOutside={discountOnTheOutside}
          handleFinalizeOrder={handleFinalizeOrder}
          isLoading={isLoading}
        />
      ) : null}
      <Aside
        cart={cart}
        selectedCompanyId={user.empresa_id}
        cartIsLoading={cartIsLoading}
        deliveryFee={deliveryFee}
        finalPrice={finalPrice}
        removeItemToCart={removeItemToCart}
        selectedAddress={selectedAddress}
        selectedClient={selectedClient}
        selectedCoupon={selectedCoupon}
        selectedDeliveryType={selectedDeliveryType}
        setDeliveryType={setDeliveryType}
        setModalCancelIsOpen={() => modalCancelRef.current?.open()}
        nextStep={nextStep}
        setSeletedEditCartItemId={setSeletedEditCartItemId}
        discountOnTheOutside={discountOnTheOutside}
        handleFinalizeOrder={handleFinalizeOrder}
        step={step}
        selectdePaymentMethod={selectdePaymentMethod}
        setAsideisClosed={setAsideisClosed}
      />
      {/*  */}
      <S.CustomModalV2
        ref={modalCancelRef}
        containerStyle={{ zIndex: 99999999 }}
      >
        <S.ModalHeader>
          <div>
            <IoIosWarning />
          </div>
          <h1>Atenção</h1>
          <button type="button" onClick={() => modalCancelRef.current?.close()}>
            <BiX />
          </button>
        </S.ModalHeader>
        <p>
          Você não salvou suas alterações. Ao realizar a ação todos os dados
          serão perdidos.
          <br />
          <strong>Deseja prosseguir?</strong>
        </p>
        <Button full onClick={() => history.push('/monitor_pedidos')}>
          Confirmar
        </Button>
        <Button
          full
          variant="outlined"
          onClick={() => modalCancelRef.current?.close()}
        >
          Cancelar
        </Button>
      </S.CustomModalV2>

      <ProductModal
        isOpen={!!seletedProductId}
        productId={seletedProductId}
        onClose={() => setSeletedProductId(null)}
        addItemToCart={addItemToCart}
        colorsAndSizesAll={colorsAndSizesAll}
      />
      <ProductEditModal
        isOpen={seletedEditCartItemId !== null}
        seletedEditProductId={
          cart?.find((item) => item.id === seletedEditCartItemId)
            ?.compositeProduct.product.id || null
        }
        onClose={() => setSeletedEditCartItemId(null)}
        editItemToCart={(payload) =>
          editItemToCart(seletedEditCartItemId!, payload)
        }
        cartItem={cart.find((item) => item.id === seletedEditCartItemId)}
        colorsAndSizesAll={colorsAndSizesAll}
      />
    </S.Container>
  );
}
